import { render, staticRenderFns } from "./simple-accordion.vue?vue&type=template&id=701cd6f0&"
import script from "./simple-accordion.vue?vue&type=script&lang=js&"
export * from "./simple-accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports